import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { modal } from '../../../helpers/decorators'
import { apiBadges } from '../../../helpers/decorators/api/dashboard'
import BadgesOverview from '../BadgesOverview/BadgesOverview'
import { get } from 'lodash'
import { apiConfiguration } from '../../../helpers/decorators/api'
import { CONFIGURATION_KEYS } from '../../../constants/enums'

@modal.trigger()
@apiBadges({ loadBadges: true, loadAwardBadges: true, loadBadgesProgress: true })
@apiConfiguration({ getValue: CONFIGURATION_KEYS.isBadgesStrictModeEnabled.id })
class Badges extends Component {
  static propTypes = {
    badges: PropTypes.object,
    awards: PropTypes.object,
    configuration: PropTypes.object
  }

  render() {
    const { badges, awards, configuration } = this.props

    const badgesData = get(badges, 'badges')

    const awardBadges = get(badges, 'awardBadges')

    const badgesProgress = get(badges, 'badgesProgress')

    const award = get(awards, 'awards.data')

    const activity = get(this.props, 'activity')

    const badgesSetting = get(configuration, `values[${CONFIGURATION_KEYS.isBadgesStrictModeEnabled.id}]`)

    const isBadgesStrictModeEnabled = badgesSetting && get(badgesSetting, 'booleanValue')

    return (
      <BadgesOverview badges={badgesData} badgesProgress={badgesProgress} awardBadges={awardBadges} award={award} activity={activity} isBadgesStrictModeEnabled={isBadgesStrictModeEnabled} />
    )
  }
}

export default Badges
